import React from 'react'
import styles from './actTotal.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'

const breakDownLine = (
  title: string,
  total: string,
  hasCrownIcon?: boolean,
) => (
  <div className={styles.breakdown}>
    <Text type="caption" weight="semiBold">
      {title}{' '}
      {hasCrownIcon && <Icon name="premium_crown" size={13} color="#FECD39" />}
    </Text>
    <Text type="caption" weight="semiBold">
      +${total}
    </Text>
  </div>
)

type Props = {
  actCardTotal?: string
  premiumDesignTotal?: string
  giftCardTotal?: string
  processingFeeTotal?: string
  taxesTotal?: string
  total?: string
}

const ActTotal: React.FC<Props> = props => {
  const {
    actCardTotal,
    premiumDesignTotal,
    giftCardTotal,
    processingFeeTotal,
    taxesTotal,
    total,
  } = props

  return (
    <div>
      {actCardTotal && breakDownLine('Act Card', actCardTotal)}
      {premiumDesignTotal &&
        breakDownLine('Premium Card Design', premiumDesignTotal, true)}
      {giftCardTotal && breakDownLine('Gift Card', giftCardTotal)}
      {processingFeeTotal &&
        breakDownLine('Processing Fee', processingFeeTotal)}
      {taxesTotal && breakDownLine('Taxes', taxesTotal)}
      <div className={styles.total}>
        <Text type="body" weight="bold">
          Total Due Today
        </Text>
        <Text type="body" weight="bold" style={{ color: '#404040' }}>
          ${total}
        </Text>
      </div>
    </div>
  )
}

export default ActTotal
